// Theme: brutalist-ui
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'brutalist-ui',
  name: 'BRUTALIST',
  tagline: 'BRUTALIST',
  description: 'Urbano limpo com assinatura brutalista em verde cimento e contraste controlado.',
  category: 'urban-expression',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#141915', '#1E2620', '#5FB86E', '#E8F4EA'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 12px 30px color-mix(in srgb, var(--primary) 24%, transparent)'
    },
    shellClasses: 'font-mono theme-brutalist-ui'
  },
  colorVars: {
    '--accent': '#5FB86E',
    '--accent-foreground': '#141915',
    '--background': '#141915',
    '--border': '#304235',
    '--card': '#1E2620',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 42%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E8F4EA',
    '--card-glow': 'color-mix(in srgb, var(--primary) 7%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#141915',
    '--foreground': '#E8F4EA',
    '--hold-fill': '#5FB86E',
    '--input': '#304235',
    '--modal-bg': '#141915',
    '--modal-border': '#304235',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.24)',
    '--muted': '#304235',
    '--muted-foreground': '#D5E8D8',
    '--nav-active': '#5FB86E',
    '--nav-bg': '#1E2620',
    '--popover': '#1E2620',
    '--popover-foreground': '#E8F4EA',
    '--primary': '#5FB86E',
    '--primary-foreground': '#141915',
    '--ring': '#5FB86E',
    '--secondary': '#304235',
    '--secondary-foreground': '#E8F4EA',
    '--streak': '#5FB86E',
    '--success': '#22c55e',
    '--success-foreground': '#141915',
    '--xp': '#5FB86E',
    '--xp-bg': '#1E2620'
  },
  resolvedVars: {
    '--accent': '#5FB86E',
    '--accent-foreground': '#141915',
    '--accent-foreground-hsl': '132 11% 9%',
    '--accent-foreground-oklch': 'from #141915 l c h',
    '--accent-hsl': '130 39% 55%',
    '--accent-oklch': 'from #5FB86E l c h',
    '--background': '#141915',
    '--background-hsl': '132 11% 9%',
    '--background-oklch': 'from #141915 l c h',
    '--border': '#304235',
    '--border-hsl': '137 16% 22%',
    '--border-oklch': 'from #304235 l c h',
    '--border-w': '1px',
    '--card': '#1E2620',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 42%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E8F4EA',
    '--card-foreground-hsl': '130 35% 93%',
    '--card-foreground-oklch': 'from #E8F4EA l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 7%, transparent)',
    '--card-hsl': '135 12% 13%',
    '--card-oklch': 'from #1E2620 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#141915',
    '--destructive-foreground-hsl': '132 11% 9%',
    '--destructive-foreground-oklch': 'from #141915 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E8F4EA',
    '--foreground-hsl': '130 35% 93%',
    '--foreground-oklch': 'from #E8F4EA l c h',
    '--hold-fill': '#5FB86E',
    '--hold-fill-hsl': '130 39% 55%',
    '--hold-fill-oklch': 'from #5FB86E l c h',
    '--input': '#304235',
    '--input-hsl': '137 16% 22%',
    '--input-oklch': 'from #304235 l c h',
    '--modal-bg': '#141915',
    '--modal-bg-hsl': '132 11% 9%',
    '--modal-bg-oklch': 'from #141915 l c h',
    '--modal-border': '#304235',
    '--modal-border-hsl': '137 16% 22%',
    '--modal-border-oklch': 'from #304235 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.24)',
    '--muted': '#304235',
    '--muted-foreground': '#D5E8D8',
    '--muted-foreground-hsl': '129 29% 87%',
    '--muted-foreground-oklch': 'from #D5E8D8 l c h',
    '--muted-hsl': '137 16% 22%',
    '--muted-oklch': 'from #304235 l c h',
    '--nav-active': '#5FB86E',
    '--nav-active-hsl': '130 39% 55%',
    '--nav-active-oklch': 'from #5FB86E l c h',
    '--nav-bg': '#1E2620',
    '--nav-bg-hsl': '135 12% 13%',
    '--nav-bg-oklch': 'from #1E2620 l c h',
    '--popover': '#1E2620',
    '--popover-foreground': '#E8F4EA',
    '--popover-foreground-hsl': '130 35% 93%',
    '--popover-foreground-oklch': 'from #E8F4EA l c h',
    '--popover-hsl': '135 12% 13%',
    '--popover-oklch': 'from #1E2620 l c h',
    '--primary': '#5FB86E',
    '--primary-foreground': '#141915',
    '--primary-foreground-hsl': '132 11% 9%',
    '--primary-foreground-oklch': 'from #141915 l c h',
    '--primary-hsl': '130 39% 55%',
    '--primary-oklch': 'from #5FB86E l c h',
    '--radius': '12px',
    '--ring': '#5FB86E',
    '--ring-hsl': '130 39% 55%',
    '--ring-oklch': 'from #5FB86E l c h',
    '--secondary': '#304235',
    '--secondary-foreground': '#E8F4EA',
    '--secondary-foreground-hsl': '130 35% 93%',
    '--secondary-foreground-oklch': 'from #E8F4EA l c h',
    '--secondary-hsl': '137 16% 22%',
    '--secondary-oklch': 'from #304235 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 12px 30px color-mix(in srgb, var(--primary) 24%, transparent)',
    '--streak': '#5FB86E',
    '--streak-hsl': '130 39% 55%',
    '--streak-oklch': 'from #5FB86E l c h',
    '--success': '#22c55e',
    '--success-foreground': '#141915',
    '--success-foreground-hsl': '132 11% 9%',
    '--success-foreground-oklch': 'from #141915 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(130 39% 55% / 0.15)',
    '--xp': '#5FB86E',
    '--xp-bg': '#1E2620',
    '--xp-bg-hsl': '135 12% 13%',
    '--xp-bg-oklch': 'from #1E2620 l c h',
    '--xp-hsl': '130 39% 55%',
    '--xp-oklch': 'from #5FB86E l c h'
  }
}
